module.exports = __webpack_public_path__ + "img/6-0-1.8cc8c152.png";